// extracted by mini-css-extract-plugin
export default {"container":"XDcQnF","inPostPage":"OdeuKJ","noMargin":"WIEJ0e","menuDisplay":"kCb5Uz","menuCategoriesDisplay":"sXtzQt","menuSearchDisplay":"IAhK9I"};